import localStore from 'store2';
var Keys;

(function (Keys) {
  Keys["featureToggle"] = "FEATURE_TOGGLE";
})(Keys || (Keys = {}));

export var setFeatures = function setFeatures(features) {
  return localStore.set(Keys.featureToggle, features);
};
export var getFeatures = function getFeatures() {
  return localStore.get(Keys.featureToggle);
};
export var updateFeature = function updateFeature(feature, options) {
  var features = getFeatures();
  features[feature] = options;
  setFeatures(features);
};